<template>
    <ui-modal ref="modal" title="Finance Quotes" class="finance-modal" size="large">
        <div class="container-fluid card" style="padding: 2rem 2rem 1rem; margin-bottom: 2rem;">
            <div class="row" style="margin-bottom: 1rem;">
                <div class="col">
                    <ui-radio-group v-model="quoteSource" :options="quoteSourceOptions" name="type"></ui-radio-group>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <ui-textbox :disabled="loading || this.fixedPrice !== undefined" label="Cash Price (£)" :value="displayPrice" @input="updateValue({attr: 'price', value: $event})" />
                </div>
                <div class="col">
                    <ui-textbox :disabled="loading || this.fixedDeposit !== undefined" label="Deposit (£)"  :value="displayDeposit" @input="updateValue({attr: 'deposit', value: $event})" />
                </div>
                <div class="col">
                    <ui-textbox :disabled="loading" label="Duration (Months)" v-model="duration" />
                </div>
                <div class="col"  v-if="quoteSource === 'provider'">
                    <ui-select :disabled="loading" label="Annual Mileage" v-model="annualMileageProxy" :options="annualMileageOptions" />
                </div>
                <div class="col"  v-if="quoteSource === 'custom-hp'">
                    <ui-textbox :disabled="loading" label="APR (%)" v-model="aprProxy" />
                </div>
            </div>
            <div class="row">
                <div class="col-3">
                    <ui-textbox :disabled="loading || this.fixedValueAddedProducts !== undefined" label="Total Product Price (£)"  :value="displayVaps" @input="updateValue({attr: 'total_value_added_products', value: $event})" />
                </div>
                <div class="col"  v-if="quoteSource === 'provider'">
                    <ui-select :disabled="loading" label="Quote Type" v-model="quoteTypeProxy" :options="quoteTypeOptions" />
                </div>
                <div class="col" v-if="shouldShowCreditRatingOptions && quoteSource === 'provider'">
                    <ui-select :disabled="loading" label="Credit Rating" v-model="creditRatingProxy" :options="creditRatingOptions" />
                </div>
                <div class="col text-center">
                    <ui-button :disabled="loading" color="primary" icon="refresh" @click="update" style="margin-top: .8rem;">Update Quotes</ui-button>
                </div>
            </div>
            </div>
        <div class="container-fluid">
            <div class="row text-center">
                <div v-if="!loading && !noQuotes" class="row col-12" style="padding: 0;">
                    <div class="col-6 mb-5" v-for="quote in orderedQuotes">
                        <finance-quote-card
                            :quote="quote"
                            :show-select-button="allowSelection"
                            @select="selected"
                        >
                        </finance-quote-card>
                    </div>
                </div>
            <div class="text-center" style="width: 100%; padding: 3rem;" v-else-if="loading">
                <ui-progress-circular :size="64" :stroke="2" style="display: inline-block;"></ui-progress-circular>
            </div>
            <div v-else style="margin:auto;">
                <hero-error-message
                    title="No Quotes Available"
                    @retry="update"
                ></hero-error-message>
            </div>
        </div>
        </div>
    </ui-modal>
</template>

<style>
    .finance-modal  > .ui-modal__wrapper > .ui-modal__container { width: 70rem; }
</style>

<script>
   import Filters from '../../../filters';
   import {debounce, sortBy} from 'lodash'
   import {VehicleInstanceFinanceQuoteResource} from "../../../classes/Api/Vehicle";
   import FinanceQuoteCard from "../../elements/FinanceQuoteCard";

   const creditRatingOptions = [
       { value: 'BELOW_AVERAGE', label: 'Below Average' },
       { value: 'FAIR', label: 'Fair' },
       { value: 'GOOD', label: 'Good' },
       { value: 'VERY_GOOD', label: 'Very Good' },
       { value: 'EXCELLENT', label: 'Excellent' },
   ];

   const quoteTypeOptions = [
       { value: 'PERSONAL', label: 'Personal' },
       { value: 'BUSINESS', label: 'Business' },
   ]

   export default {
       components: {FinanceQuoteCard},
       props: {
            instance: {
                type: Object,
                required: true
            },
           allowSelection: {
               type: Boolean,
               default: false
           },
           priceOverride: {
               type: Number,
               required: false
           },
           fixedPrice: {
                type: Number | String,
               required: false
           },
           fixedDeposit: {
                type: Number | String,
               required: false
           },
           fixedValueAddedProducts: {
                type: Number,
               required: false
           }
        },
       filters: Filters,
       data() {
           return {
               apr: 13.9,
               quotes: [],
               price: 0,
               total_value_added_products: 0,
               deposit: 0,
               duration: 0,
               annual_mileage: 0,
               credit_rating: '',
               quote_type: 'PERSONAL',
               risk_based_lending: false,
               loading: false,
               creditRatingOptions,
               quoteTypeOptions,
               quoteSource: 'provider',
               quoteSourceOptions: [
                   { label: 'Provider', value: 'provider' },
                   { label: 'Custom HP', value: 'custom-hp' }
               ]
           }
       },
       methods: {
            open() {
                this.loading = true

                VehicleInstanceFinanceQuoteResource.forInstance(this.instance.id).defaultExamples().then(r => {
                    this.quotes = r.data.quotes
                    this.price = this.priceOverride ? this.priceOverride : r.data.defaults.retail_price
                    this.deposit = parseInt(r.data.defaults.deposit)
                    this.total_value_added_products = parseInt(r.data.defaults.total_value_added_products)
                    this.duration = parseInt(r.data.defaults.term)
                    this.annual_mileage = parseInt(r.data.defaults.annual_mileage)
                    this.risk_based_lending = r.data.defaults.risk_based_lending
                    this.credit_rating = r.data.defaults.credit_rating
                    this.loading = false

                    if (this.fixedPrice) {
                        this.price = this.fixedPrice
                    }

                    if (this.fixedDeposit) {
                        this.deposit = this.fixedDeposit
                    }

                    if (this.fixedValueAddedProducts) {
                        this.total_value_added_products = this.fixedValueAddedProducts
                    }

                    if (this.fixedPrice || this.fixedDeposit || this.fixedValueAddedProducts) {
                        this.update()
                    }
                }).catch(handleApiError);

               this.$refs.modal.open()
            },
            close() {
                this.$refs.modal.close()
            },
           selected(quote) {
               this.$emit('select', quote)
               this.close()
           },
           updateValue: debounce(function({attr, value}) {
                let clean = value
                    .replace(/(\.[0-9]{1,2})/g, '') // Remove trailing pence
                    .replace(/[^0-9]/g,'') // Remove all non-numeric values

                if (clean !== this.price) {
                    this[attr] = isNaN(parseFloat(clean)) ? 0 : clean
                }
           }, 50),
           update() {
            this.loading = true

            VehicleInstanceFinanceQuoteResource.forInstance(this.instance.id)
                .lookup(this.quoteSource, this.price, this.duration, this.deposit, this.annual_mileage, this.credit_rating, this.quote_type, this.total_value_added_products, this.apr)
                .then(r => {
                    this.quotes = r.data
                    this.loading = false
                }).catch(e => { this.loading = false; handleApiError(e) });
           }
       },
       computed: {
           orderedQuotes() {
               return sortBy(this.quotes, quote => quote.monthly_payment)
           },
           shouldShowCreditRatingOptions() {
               return this.risk_based_lending === true && this.quote_type === 'PERSONAL'
           },
           noQuotes() {
                return this.quotes.length === 0
           },
           displayPrice() {
               if (this.price > 0) {
                   return this.$options.filters.formatNumber(this.price, 0)
               }
           },
           displayVaps() {
               if (this.total_value_added_products > 0) {
                   return this.$options.filters.formatNumber(this.total_value_added_products, 0)
               }

               return 0
           },
           displayDeposit() {
               if (this.deposit > 0) {
                   return this.$options.filters.formatNumber(this.deposit, 0)
               }

               return 0
           },
           annualMileageProxy: {
               get() {
                   let result = this.annualMileageOptions.filter(o => this.annual_mileage === o.value)
                   return result.length > 0 ? result[0] : { value: 10000, label: '10,000' }
               },
               set(value) {
                   if (value) {
                       this.annual_mileage = value.value
                   }
               }
           },
           creditRatingProxy: {
               get() {
                   let result = this.creditRatingOptions.filter(o => this.credit_rating === o.value)
                   return result.length > 0 ? result[0] : { value: 'EXCELLENT', label: 'Excellent' }
               },
               set(value) {
                   if (value) {
                       this.credit_rating = value.value
                   }
               }
           },
           quoteTypeProxy: {
               get() {
                   let result = this.quoteTypeOptions.filter(o => this.quote_type === o.value)
                   return result.length > 0 ? result[0] : { value: 'PERSONAL', label: 'Personal' }
               },
               set(value) {
                   if (value) {
                       this.quote_type = value.value
                   }
               }
           },
           aprProxy: {
               get() {
                   return this.apr
               },
               set(value) {
                   if (value) {
                       this.apr = value
                       return
                   }

                   this.apr = 0
               }
           },
           annualMileageOptions() {
               let options = []
               let value = 0

               while (options.length <= 42) {
                   value = 1000 * (options.length + 3);
                   options.push({ value, label: this.$options.filters.formatNumber(value, 0) })
               }

               return options
           }
       }
   }
</script>